import type React from "react"
import { memo } from "react"

interface DirectionArrowProps {
  direction: "bidirectional" | "one-way"
}

const DirectionArrow: React.FC<DirectionArrowProps> = memo(({ direction }) => {
  if (direction === "bidirectional") {
    return (
      <div className="direction-arrow bidirectional">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 11l4 4-4 4" />
          <path d="M7 13l-4-4 4-4" />
          <path d="M21 15H3" />
          <path d="M21 9H3" />
        </svg>
      </div>
    )
  }

  return (
    <div className="direction-arrow unidirectional">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M5 12h14" />
        <path d="M12 5l7 7-7 7" />
      </svg>
    </div>
  )
})

DirectionArrow.displayName = "DirectionArrow"

export default DirectionArrow
